import { makeStyles } from "tss-react/mui";

export const useRowMenuFileItemStyles = makeStyles()((theme) => ({
  wrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    minWidth: "285px",
    width: "100%",
    "@media (max-width: 340px)": { minWidth: "250px" },
  },

  leftSide: {
    display: "flex",
    alignItems: "center",
    gap: 12,
  },

  text: {
    color: theme.palette.text.primary,
  },

  fab: {
    pointerEvents: "none",
  },
}));

export default useRowMenuFileItemStyles;
